// 供应商类
class Supplier{
  constructor(
    name = null,               // 名称
    level = null,              // 星级
    provinceId = null,         // 省
    cityId = null,             // 市
    countyId = null,           // 区
    address = null,            // 地址
    addressComplate = null,    // 详细地址
    contact = null,            // 联系人
    phone = null,              // 联系方式
    telephone = null,          // 座机
    qq = null,                 // QQ
    ali = null,                // 旺旺
    remark = null,             // 备注
    time = null,               // 创建时间
    warehouse = [],            // 仓库
    id = null                  // ID
  ){
    this.name = name
    this.level = level
    this.provinceId = provinceId
    this.cityId = cityId
    this.countyId = countyId
    this.address = address
    this.addressComplate = addressComplate
    this.contact = contact
    this.phone = phone
    this.telephone = telephone
    this.qq = qq
    this.ali = ali
    this.remark = remark
    this.time = time
    this.warehouse = warehouse
    this.id = id
  }
  getNewAxiosBody(){
    return{
      "supplierName": this.name,
      "starLevel": this.level,
      "provinceId":this.provinceId,
      "cityId":this.cityId,
      "countyId":this.countyId,
      "address": this.address,
      "contact": this.contact,
      "phone": this.phone,
      "telephone": this.telephone,
      "qq": this.qq,
      "ali": this.ali,
      "remarks": this.remark
    }
  }
  getAxiosBody(){
    return{
      "supplierId": this.id,
      "supplierName": this.name,
      "starLevel": this.level,
      "provinceId":this.provinceId,
      "cityId":this.cityId,
      "countyId":this.countyId,
      "address": this.address,
      "contact": this.contact,
      "phone": this.phone,
      "telephone": this.telephone,
      "qq": this.qq,
      "ali": this.ali,
      "remarks": this.remark
    }
  }
  judgeIsOver(){
    return (
      this.name &&
      this.level &&
      this.phone &&
      this.contact &&
      this.provinceId &&
      this.cityId &&
      this.countyId &&
      this.address
    )
  }
  clearData(){
    this.name = null
    this.level = null
    this.provinceId = null
    this.cityId = null
    this.countyId = null
    this.address = null
    this.addressComplate = null
    this.contact = null
    this.phone = null
    this.telephone = null
    this.qq = null
    this.ali = null
    this.remark = null
    this.time = null
    this.warehouse = []
    this.id = null
  }
}

// 供应商选择器子项
class SupplierOption{
  constructor(value, label, disabled = false){
    this.value = value
    this.label = label
    this.disabled = disabled
  }
}

export {
  Supplier, SupplierOption
}
